export const APPEND_TO = {
  window: 'window',
  viewport: 'viewport',
  scrollParent: 'scrollParent',
  parent: 'parent',
} as const;

export const placements = [
  'top',
  'top-start',
  'top-end',
  'right',
  'right-start',
  'right-end',
  'bottom',
  'bottom-start',
  'bottom-end',
  'left',
  'left-start',
  'left-end',
  'auto',
  'auto-start',
  'auto-end',
];
